import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {map, Observable, of, shareReplay} from "rxjs";
import {BreakpointObserver, Breakpoints, BreakpointState} from "@angular/cdk/layout";
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ObserveBreakpointService {

	public isMobile$: Observable<boolean>;
	private static tailwindBreakpoints = {
		sm: '(min-width: 640px)',
		md: '(min-width: 768px)',
		lg: '(min-width: 1024px)',
		xl: '(min-width: 1280px)',
	};

	constructor(
		private breakpointObserver: BreakpointObserver,
		@Inject(PLATFORM_ID) private platformId: Object
	) {
		if(isPlatformBrowser(this.platformId)) {
			this.isMobile$ = this.breakpointObserver.observe([Breakpoints.Handset])
				.pipe(
					map(result => result.matches),
					shareReplay(1)
				);
		}
		else {
			this.isMobile$ = of(false);
		}
	}

	public observe(bp: keyof typeof ObserveBreakpointService.tailwindBreakpoints): Observable<boolean> {
		if (!isPlatformBrowser(this.platformId)) {
			return of(false);
		}

		return this.breakpointObserver.observe(ObserveBreakpointService.tailwindBreakpoints[bp])
			.pipe(
				map((state: BreakpointState) => state.matches),
				shareReplay(1)
			);
	}


	public observeMany(bps: (keyof typeof ObserveBreakpointService.tailwindBreakpoints)[]): Observable<Record<string, boolean>> {
		if (!isPlatformBrowser(this.platformId)) {
			return of({});
		}

		const queries = bps.map(bp => ObserveBreakpointService.tailwindBreakpoints[bp]);

		return this.breakpointObserver.observe(queries).pipe(
			map(state => {
				const result: Record<string, boolean> = {};
				bps.forEach(bp => {
					result[bp] = state.breakpoints[ObserveBreakpointService.tailwindBreakpoints[bp]] || false;
				});
				return result;
			}),
			shareReplay(1)
		);
	}
}
